<template>
  <div>
    <b-button type="is-dark" v-on:click="edit = true">Produktionsverfahren</b-button>

    <b-modal :active.sync="edit" :width="1200" has-modal-card>
       <div class="modal-card produktionsverfahren" style="width: auto">
        <header class="modal-card-head">
                <p class="modal-card-title">Produktionsverfahren bearbeiten</p>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div v-for="number in 5" class="column" style="text-align:left;">

              <h6 class="title is-6">Produktionsverfahren {{number}}</h6>

              <div v-if="gameProductions.length < number">
                <b-button
                   icon-left="plus-circle" v-on:click="addGameProduction(number)">
                   Hinzufügen
               </b-button>
              </div>

              <div v-if="gameProductions.length >= number">
              <b-field label="Hersteller">
                <multiselect class="is-small" v-model="gameProductions[number-1].producer" :show-labels="false" placeholder="Hersteller auswählen" :options="allproducer" :multiple="false"  track-by="id" label="name" :close-on-select="true"></multiselect>
              </b-field>
              <b-field label="Druckverfahren">
                <multiselect class="is-small" v-model="gameProductions[number-1].printprocedure" :show-labels="false" placeholder="Druckverfahren auswählen" :options="allprintprocedures" :multiple="false"  track-by="id" label="name" :close-on-select="true"></multiselect>
              </b-field>
              <b-field label="Nicht für Wl-Partner">
                <multiselect class="is-small" v-model="gameProductions[number-1].whiteLablePartner" :show-labels="false" placeholder="Whitelabel-Partner auswählen" :options="allwhitelabelpartners" :multiple="true"  track-by="id" label="name" :close-on-select="true"></multiselect>
              </b-field>
              <b-field  label="Produktionszeit">
                <b-numberinput size="is-small" v-model="gameProductions[number-1].productiontime"></b-numberinput>
              </b-field>
<!--              <b-field label="Link Preisliste">
                <b-input maxlength="255" size="is-small" v-model="gameProductions[number-1].producerPricelistURL"></b-input>
              </b-field>
              <b-field label="Link Druckvorgaben">
                <b-input maxlength="255" size="is-small" v-model="gameProductions[number-1].printGuidelineURL"></b-input>
              </b-field>-->
              <b-field label="Zoho-Code">
                <b-input maxlength="255" size="is-small" v-model="gameProductions[number-1].zohoCode" readonly="true"></b-input>
              </b-field>
              <b-field label="Lizenzkosten" message="pro Stück">
                <b-input pattern="[+]?[0-9]*\.?[0-9]+" size="is-small" placeholder="0.00" v-model="gameProductions[number-1].licenseCost"></b-input>
              </b-field>
              <b-field label="Material">
                <multiselect class="is-small" v-model="gameProductions[number-1].material" :show-labels="false" placeholder="Material auswählen" :options="allmaterials" :multiple="false"  track-by="id" label="name" :close-on-select="true"></multiselect>
              </b-field>
                <!--<b-field label="Material-Old">
                  <b-input maxlength="255" size="is-small" v-model="gameProductions[number-1].materialOld"></b-input>
                </b-field>
                <b-field label="Sonderinfo">
                  <b-input maxlength="255" size="is-small" v-model="gameProductions[number-1].specialInformation"></b-input>
                </b-field> -->
               <!--<b-field label="Aufschlagsatzstaffel">
                <multiselect class="is-small" v-model="gameProductions[number-1].extraCharge" :show-labels="false" placeholder="Aufschlagsatzstaffel auswählen" :options="allextracharge" :multiple="false"  track-by="id" label="name" :close-on-select="true"></multiselect>
              </b-field> -->

              <label class="label">Kosten nach Auflage</label>
              <div style="overflow: auto; margin-bottom: 0.75rem;">
                <b-field v-for="(item, index) in gameProductions[number-1].gameCharge" v-if="index != 'id'" :message="index">
                   <!-- <b-numberinput step="0.001" size="is-small" v-model="gameProductions[number-1].gameCharge[index]"></b-numberinput> -->
                   <b-input pattern="[+]?[0-9]*\.?[0-9]+" size="is-small" v-model="gameProductions[number-1].gameCharge[index]"></b-input>
               </b-field>
              </div>



            <!--  <label class="label">ExtraCharge</label>
              <div style="max-height: 170px;overflow: auto">
                <b-field v-for="(item, index) in gameProductions[number-1].extraCharge" v-if="index != 'id'" :message="index">
                   <b-numberinput size="is-small" v-model="gameProductions[number-1].extraCharge[index]"></b-numberinput>
               </b-field>
             </div> -->

            <label class="label">ColourCharge</label>
              <div style="overflow: auto">
                <b-field v-for="(item, index) in gameProductions[number-1].colourCharge" v-if="index != 'id'" :message="index">
                  <!-- <b-numberinput step="0.001" size="is-small" v-model="gameProductions[number-1].colourCharge[index]"></b-numberinput>-->
                  <b-input pattern="[+]?[0-9]*\.?[0-9]+" size="is-small" v-model="gameProductions[number-1].colourCharge[index]"></b-input>
               </b-field>
              </div>

              <div style="margin-top:20px;">
                <b-button
                   icon-left="minus-circle" v-on:click="removeGameProduction(number)">
                   Entfernen
               </b-button>
              </div>

            </div>

            </div>
          </div>

        </section>

        <footer class="modal-card-foot">
                <b-button class="button is-primary" @click="saveAllGameProduction">Übernehmen</b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
const axios = require('axios');

import Multiselect from 'vue-multiselect'

    export default {
      props: ['selected'],
      components: {
	       Multiselect
    	},
        data(){
          return {
            edit: false,
            //gameProductions: [],
            gameProductions: [],
            allproducer: [],
            allprintprocedures: [],
            allextracharge: [],
            allwhitelabelpartners: [],
            allmaterials: []
          }
        },
        watch: {
          selected(val) {
              this.gameProductions = val;
              this.prepareGameProductionsArray();
              console.log("TEST");
              console.log(this.gameProductions);
          },
          gameProductions(val) {
            console.log("CHANEE");
            this.$emit('input', val);
          }
        },
        mounted() {
          console.log('Component mounted3.');
          this.getProducer();
          //this.getExtraCharge();
          this.getPrintprocedures();
          this.getWhiteLabelPartners();
          this.getMaterials();
        },
        methods: {
          getWhiteLabelPartners() {
            var _this = this;
            axios.get('/api/whitelablepartner', {
              withCredentials: true,
            })
            .then(function (response) {
              console.log("WHITELABEL");
              console.log(response.data);
              _this.allwhitelabelpartners = response.data;
              //_this.loading = false;
            })
            .catch(function (error) {
              console.log(error);
              //  _this.loading = false;
            })
            .then(function () {
              // always executed
            });
          },
          getProducer: function() {
            var _this = this;
            axios.get('/api/producers', {
              withCredentials: true,
            })
            .then(function (response) {
              console.log("PRODUCER");
              console.log(response.data);
              _this.allproducer = response.data;
              //_this.loading = false;
            })
            .catch(function (error) {
              console.log(error);
              //  _this.loading = false;
            })
            .then(function () {
              // always executed
            });
          },
          getMaterials: function() {
            var _this = this;
            axios.get('/api/materials', {
              withCredentials: true,
            })
            .then(function (response) {
              console.log("MATERIALS");
              console.log(response.data);
              _this.allmaterials = response.data;
              //_this.loading = false;
            })
            .catch(function (error) {
              console.log(error);
              //  _this.loading = false;
            })
            .then(function () {
              // always executed
            });
          },

          getPrintprocedures: function() {
            var _this = this;
            axios.get('/api/printprocedures', {
              withCredentials: true,
            })
            .then(function (response) {
              console.log("printprocedures");
              console.log(response.data);
              _this.allprintprocedures = response.data;
              //_this.loading = false;
            })
            .catch(function (error) {
              console.log(error);
              //  _this.loading = false;
            })
            .then(function () {
              // always executed
            });
          },

         /* getExtraCharge: function() {
            var _this = this;
            axios.get('/api/extracharge', {
              withCredentials: true,
            })
            .then(function (response) {
              console.log("EXTRA CHARGE");
              console.log(response.data);
              _this.allextracharge = response.data;
              //_this.loading = false;
            })
            .catch(function (error) {
              console.log(error);
              //  _this.loading = false;
            })
            .then(function () {
              // always executed
            });
          },*/

          prepareGameProductionsArray: function() {
            console.log("JSON");
            console.log(empyGameProduction);
            if (this.gameProductions.length == 1) {
              //this.gameProductions.push( empyGameProduction );
            }

          },
          addGameProduction: function(number) {
            console.log("Add "+number);
            //var newGameProd = Object.assign({}, empyGameProduction);
              var newGameProd = _.cloneDeep(empyGameProduction);
                //Producer 1 als standard setzen
              newGameProd.producer = this.allproducer[0];
                //Extra CHarge 1 als standard setzen
                //newGameProd.extraCharge = this.allextracharge[0];
            console.log(empyGameProduction);
          //  this.gameProductions[0] = empyGameProduction;
            this.gameProductions.push(newGameProd);

          },
          removeGameProduction: function(number) {
            console.log("Remove "+number);
            this.gameProductions.splice(number-1, 1);
        //    this.gameProductions.push(newGameProd);
          },
          saveAllGameProduction: function() {
            this.$emit('input', this.gameProductions);
            this.edit = false;
          }
        },
      }

      const empyGameProduction =
          {
        gameCharge: {
        //  id: 0,
          pac100: null,
          pac150: null,
          pac200: null,
          pac250: null,
          pac300: null,
          pac400: null,
          pac500: null,
          pac750: null,
          pac1000: null,
          pac1500: null,
          pac2000: null,
          pac2500: null,
          pac3000: null,
          pac4000: null,
          pac5000: null,
          pac7500: null,
          pac10000: null,
          pac15000: null,
          pac20000: null,
          pac30000: null,
          pac50000: null,
          pac100000: null
        },
        colourCharge: {
        //  id: 0,
          pac100: null,
          pac150: null,
          pac200: null,
          pac250: null,
          pac300: null,
          pac400: null,
          pac500: null,
          pac750: null,
          pac1000: null,
          pac1500: null,
          pac2000: null,
          pac2500: null,
          pac3000: null,
          pac4000: null,
          pac5000: null,
          pac7500: null,
          pac10000: null,
          pac15000: null,
          pac20000: null,
          pac30000: null,
          pac50000: null,
          pac100000: null
        },
        productiontime: 0,
        licenseCost: null,
        producerPricelistURL: "string",
        printGuidelineURL: "string",
        material: "string"
        }
        ;
</script>
<style lang="scss">
.produktionsverfahren .label {
    font-size: 14px;
  }
.multiselect.is-small {
      min-height: 27px;
          font-size: 0.75rem;
              color: #363636;
}
.multiselect.is-small  .multiselect__select {
    position: absolute;
    width: 40px;
    height: 27px;
  }
.multiselect.is-small  .multiselect__tags {
    min-height: 27px;
    display: block;
    padding: 4px 40px 0 4px;
  }
  .multiselect.is-small  .multiselect__input,
  .multiselect.is-small  .multiselect__single {
      font-size: 0.75rem;
      margin-bottom: 3px;
  }

</style>
